import {useState, useEffect} from "react";
import MainLayout from "../../components/MainLayout";
import {Dropdown} from "primereact/dropdown";
import {TabView, TabPanel} from "primereact/tabview";
import {useNavigate} from "react-router-dom";
import {toast} from "react-toastify";
import {BreadCrumb} from "primereact/breadcrumb";
import {QRCodeCanvas} from "qrcode.react";
import {Printer} from "lucide-react";
import {printLabel, connectQZTray, getPrinters} from "../../utils/qzHelper";
import ClientTab from "./components/clientComponent";
import StoreTab from "./components/storeComponent";

const SerialGenerationPage = () => {
	const navigate = useNavigate();
	const [activeIndex, setActiveIndex] = useState(0);
	const [tempVipusks, setTempVipusks] = useState([]);
	const [printers, setPrinters] = useState([]);
	const [selectedPrinter, setSelectedPrinter] = useState("");

	const handleVipuskCreated = (vipusk) => {
		setTempVipusks((temps) => [...temps, vipusk]);
	};

	const initializeQZTray = async () => {
		try {
			await connectQZTray();
			const availablePrinters = await getPrinters();
			setPrinters(availablePrinters);
			const savedPrinter = localStorage.getItem("selectedPrinter");
			if (savedPrinter && availablePrinters.includes(savedPrinter)) {
				setSelectedPrinter(savedPrinter);
			}
		} catch (err) {
			// console.log("QZ Tray error:", err);
		}
	};

	useEffect(() => {
		initializeQZTray();
	}, []);

	const item = [
		{
			label: "Накладнойлар",
			template: () => (
				<span className="cursor-pointer" onClick={() => navigate("/generated")}>
					Серия рақамлар
				</span>
			),
		},
		{
			label: "Серия рақам яратиш",
			template: () => (
				<span
					className="font-semibold cursor-pointer"
					onClick={() => navigate("/generation")}>
					Серия рақам яратиш
				</span>
			),
		},
	];

	return (
		<MainLayout header="Серия рақам олиш">
			{<BreadCrumb model={item} className="px-0 pt-0 pl-4 mb-4" />}
			<div className="flex justify-center w-full mb-12">
				<TabView
					activeIndex={activeIndex}
					onTabChange={(e) => setActiveIndex(e.index)}
					className="w-full mx-auto border-none">
					<TabPanel
						header={
							<span
								className={`pb-2 ${
									activeIndex === 0 ? "border-b-2 border-blue-500" : ""
								}`}>
								Заказ
							</span>
						}>
						<ClientTab onVipuskCreated={handleVipuskCreated} />
					</TabPanel>
					<TabPanel
						header={
							<span
								className={`pb-2 ${
									activeIndex === 1 ? "border-b-2 border-blue-500" : ""
								}`}>
								Супермаркет
							</span>
						}>
						<StoreTab onVipuskCreated={handleVipuskCreated} />
					</TabPanel>
				</TabView>
			</div>

			{/* Временные выпуски */}
			{tempVipusks.length > 0 && (
				<div className="mt-8 mb-2">
					<div className="flex items-center justify-between">
						<h2 className="px-4 mb-6 text-2xl font-bold text-gray-800">
							Яратилган серия рақамлар
						</h2>
						{/* Printer Selection */}
						<div className="flex justify-end px-4 mb-6">
							<div className="w-full md:w-64">
								<Dropdown
									value={selectedPrinter}
									onChange={(e) => setSelectedPrinter(e.value)}
									options={printers}
									placeholder="Принтер танланг"
									className="w-full border"
								/>
							</div>
						</div>
					</div>
					<div className="grid grid-cols-1 gap-4 px-4 md:grid-cols-2">
						{tempVipusks.map((vipusk) => {
							const category = vipusk.furniture?.category?.name;
							const komplekt = vipusk.furniture?.komplekt?.name;
							const mebel = vipusk.furniture?.name || "Супермаркет";
							const furnitureFullname = `${category} ${komplekt} ${mebel}`;
							const demandNumber = vipusk?.demand_furniture?.demand?.doc_no;
							const color = vipusk?.demand_furniture?.color?.name || "Rang";
							const packageQuantity = vipusk?.unique?.package_quantity;

							const handlePrint = () => {
								if (!selectedPrinter) {
									toast.error("Принтерни танланг: G500");
									return;
								}
								printLabel(
									selectedPrinter,
									vipusk.unique.name,
									demandNumber,
									furnitureFullname,
									color,
									packageQuantity,
								);
							};

							return (
								<div
									key={vipusk.id}
									className="flex items-center gap-4 p-4 transition-shadow bg-white border-2 shadow-md rounded-xl hover:shadow-lg">
									<div className="flex-shrink-0 p-3 rounded-lg bg-gradient-to-br from-blue-50 to-blue-100">
										<QRCodeCanvas value={vipusk.unique?.name} size={120} />
									</div>
									<div className="flex-1 min-w-0">
										<p className="mb-2 text-2xl font-bold text-gray-800 truncate">
											Серия #{vipusk.unique?.name}
										</p>
										<p className="mb-2 text-base text-gray-600">
											{category} ─ {komplekt} ─ {mebel}
										</p>
										{vipusk.demand_furniture && (
											<p className="mb-2 text-lg font-semibold text-blue-600">
												Заказ #{demandNumber}
											</p>
										)}
										<div className="flex flex-wrap gap-2 mt-2">
											<span className="px-3 py-1 text-xs font-medium text-orange-700 bg-orange-100 rounded-full">
												Миқдор: {vipusk.amount}
											</span>
											<span className="px-3 py-1 text-xs font-medium text-indigo-700 bg-indigo-100 rounded-full">
												Упаковка: {packageQuantity}
											</span>
											{vipusk.demand_furniture?.color && (
												<span className="px-3 py-1 text-xs font-medium text-pink-700 bg-pink-100 rounded-full">
													{color}
												</span>
											)}
										</div>
									</div>
									<div
										className="flex-shrink-0 ml-2 transition-transform cursor-pointer"
										onClick={handlePrint}>
										<Printer
											width={40}
											height={40}
											className="text-gray-600 transition-colors hover:text-blue-600"
										/>
									</div>
								</div>
							);
						})}
					</div>
				</div>
			)}
		</MainLayout>
	);
};

export default SerialGenerationPage;
